
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters('products', { mortgage: 'get' }),
      ...mapGetters('search', { search: 'get' }),
      comparison () {
        return this.mortgage.comparison;
      },
      mortgageStage () {
        return this.search.stage ? this.search.stage : 'applying';
      },
      mortgagePurpose () {
        return this.search.purpose === 'FTB' ? 'first-time-buyer' : this.search.purpose === 'SM' ? 'switching-mortgage' : this.search.purpose === 'TRD' ? 'moving-home' : 'lifetime-loan';
      }
    },
    methods: {
      saveToCookies () {
        const productCookie = {
          'institution': this.mortgage.institution ? this.mortgage.institution.name : '',
          'plan': this.mortgage.name,
          'link': this.comparison && this.comparison.url ? this.comparison.url.link : ''
        };
        this.$cookies.set('bonkers-ie-selected-product', productCookie);
      }
    }
  };
